import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { IKeepInTouchScore, IKeepInTouchScoreUpdateRequest } from '../../models/KeepInTouchAgent';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface UpdateScoreVariables {
	scoreId: string;
	request: IKeepInTouchScoreUpdateRequest;
}

export const useUpdateKeepInTouchScore = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IKeepInTouchScore) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ scoreId, request }: UpdateScoreVariables) => {
			return userSession.webServiceHelper.callAsync<IKeepInTouchScore>(
				`keepInTouch/scores/${encodeURIComponent(scoreId)}/notes`,
				'PUT',
				request
			);
		},
		onError,
		onSuccess,
	});
};
